import {Moment} from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'underscore';

import {CalendarFilesByDate} from 'calendar/CalendarConstants';

import {momentPropType} from './CalendarStore';
import DailyFileActivity from './DailyFileActivity';

interface WeeklyFileActivityProps {
  files: CalendarFilesByDate;
  weekStart: Moment;
}

function WeeklyFileActivity({files, weekStart}: WeeklyFileActivityProps): JSX.Element {
  return (
    <table className="calendarTable">
      <tbody>
        <tr>
          {_.range(7).map((dayNum) => {
            const date = weekStart.clone().add(dayNum, 'days');
            return (
              <DailyFileActivity
                key={dayNum}
                compact={true}
                files={files[date.format('YYYY-MM-DD')] || []}
                renderAsTD={true}
              />
            );
          })}
        </tr>
      </tbody>
    </table>
  );
}

WeeklyFileActivity.propTypes = {
  files: PropTypes.object.isRequired,
  weekStart: momentPropType.isRequired,
};

export default WeeklyFileActivity;
